import * as signalR from "@microsoft/signalr";

export class SystemSignalRService {
  private connection: signalR.HubConnection;
  private systemDataUrl: string;
  private onBaseballUpdateReceived?: (props: any) => void;
  private onNewBaseballReceived?: (props: any) => void;
  private onDeleteBaseballReceived?: (props: any) => void;
  private onGolfBroadcastCurrentReceived?: (props: any) => void;

  constructor(systemDataUrl: string) {
    this.systemDataUrl = systemDataUrl;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.systemDataUrl)
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.connection.serverTimeoutInMilliseconds = 100000;

    this.connection.start();
    this.connection.onclose(async (error) => {
      console.log("SignalR Connection:", this.connection.state);
      if (error) {
        console.log(`connection error. retrying`);
      }
      await this.start().then(() => {
        console.log("SignalR Connection:", this.connection.state);
      });
    });
  }

  // Baseball Subscribtion Event Handlers

  public subscribeBaseballEventHandlers = (
    onSystemUpdateReceived: (props: any) => void,
    onNewSystemReceived: (props: any) => void,
    onDeleteSystemReceived: (props: any) => void
  ) => {
    this.onBaseballUpdateReceived = onSystemUpdateReceived;
    this.onNewBaseballReceived = onNewSystemReceived;
    this.onDeleteBaseballReceived = onDeleteSystemReceived;
    this.onBaseballUpdateReceived &&
      this.connection.on(
        "ReceiveUpdatedSystems",
        this.onBaseballUpdateReceived
      );
    this.onNewBaseballReceived &&
      this.connection.on("ReceiveAddedSystems", this.onNewBaseballReceived);
    this.onDeleteBaseballReceived &&
      this.connection.on(
        "ReceiveDeletedSystems",
        this.onDeleteBaseballReceived
      );
  };

  public unsubscribeBaseballEventHandlers = () => {
    this.onBaseballUpdateReceived = undefined;
    this.onNewBaseballReceived = undefined;
    this.onDeleteBaseballReceived = undefined;
    this.connection.off("ReceiveUpdatedSystems");
    this.connection.off("ReceiveAddedSystems");
    this.connection.off("ReceiveDeletedSystems");
  };

  public subscribeGolfBroadcastEventHandlers = (
    onSystemUpdateReceived: (props: any) => void
  ) => {
    this.onGolfBroadcastCurrentReceived = onSystemUpdateReceived;
    this.onGolfBroadcastCurrentReceived &&
      this.connection.on(
        "ReceiveCurrentBroadcast",
        this.onGolfBroadcastCurrentReceived
      );
  };

  public unsubscribeGolfBroadcastEventHandlers = () => {
    this.onGolfBroadcastCurrentReceived = undefined;
    this.connection.off("ReceiveCurrentBroadcast");
  };

  start = async () => {
    try {
      await this.connection.start();
      console.log("connected");
    } catch (err) {
      console.log(`error connecting:`, err);
      setTimeout(() => this.start(), 5000);
    }
  };

  stop = () => {
    this.unsubscribeBaseballEventHandlers();
    this.connection.stop();
  };
}
